export default "__VITE_ASSET__BM5Boj9M__"